import styled from 'styled-components'

export const NavUl = styled.ul`
  margin: 1rem auto;
  color: #5b73a0;
`
export const NavLi = styled.li`
  display: flex;
  align-items: center;
  margin: 2rem;
  cursor: pointer;
`

export const LinkHolder = styled.span`
  display: flex;
  align-items: center;
`
export const Container = styled.aside`
  /* position: fixed;
  top: 0;
  bottom: 0;
  left: 0; */
  background-color: white;
  height: 100%;
  width: 15rem;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: 'center';
  margin-top: '1rem';
  box-shadow: 4px 4px 10px rgba(218, 221, 232, 0.7);
  @media (max-width: 768px) {
    /* position:static */
    display: flex;
    width: 100vw;
    max-height: 20%;
  }
  .logo {
    @media (max-width: 768px) {
      display: none;
    }
  }
`

export const SignOut = styled(NavLi)`
  display: none;
  @media (max-width: 768px) {
    display: flex;
  }
`
